import './styles.scss'

import { useState } from 'react'
import { Select } from 'antd'
import type { RefSelectProps } from 'antd'
import { clsx } from 'clsx'

import { ChevronDownIcon, ChevronUpIcon } from '@/components/Icons'

type B2becCustomSelectProps =
  & {
    onDropdownVisibleChange?: (visible: boolean) => void
    getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement
    className?: string | null
    loading?: boolean
    ref?: React.Ref<RefSelectProps>
  }
  & Omit<
    React.ComponentProps<typeof Select>,
    | 'onDropdownVisibleChange'
    | 'getPopupContainer'
    | 'className'
    | 'loading'
    | 'ref'
  >

const B2becCustomSelect = ({
  onDropdownVisibleChange,
  getPopupContainer,
  className = null,
  loading = false,
  ref,
  ...rest
}: B2becCustomSelectProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOnDropdownVisibleChange = (visible: boolean) => {
    setIsOpen(visible)
    if (typeof onDropdownVisibleChange === 'function') {
      onDropdownVisibleChange(visible)
    }
  }

  const suffixIcon = loading ? null : isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />

  return (
    <div className="b2bec-select">
      <Select
        {...rest}
        ref={ref}
        className={clsx('custom-ant-select', className)}
        dropdownAlign={{ offset: [0, -1] }}
        getPopupContainer={getPopupContainer}
        popupClassName="custom-select-dropdown"
        suffixIcon={suffixIcon}
        onOpenChange={(visible) => handleOnDropdownVisibleChange(visible)}
      />
    </div>
  )
}

export default B2becCustomSelect
